import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  Alert
} from "reactstrap"
import { Link, useHistory } from "react-router-dom"
import { get, post } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import cogoToast from 'cogo-toast';
import Select from "react-select"
import { connect } from "react-redux"

const NewFloor = props => {

  const history = useHistory();

  const [name, setName] = useState('');
  const [building, setBuilding] = React.useState(null);
  const [status, setStatus] = React.useState(1);

  const [buildings, setBuildings] = React.useState([]);

  const [errors, setErrors] = React.useState([]);

  
  const [loading, setLoading] = React.useState(false);
  const [initializing, setInitializing] = React.useState(true);

  const fetchData = (id) => {
    setLoading(true);
      console.log('Fetching ', id);
      get(url.GET_FLOOR+'/'+id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setName(response.data.name);
        if(response.data.building && response.data.building.id) {
          setBuilding({value: response.data.building.id, label: response.data.building.name});
        }
        setStatus(response.data.status);
        setLoading(false);
      }
      else {
        cogoToast.error('Could not fetch Floor data');
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };

  const init = () => {
    setInitializing(true);
      get(url.GET_NEW_FLOOR+'/'+props.filterBlock.id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setBuildings(response.data.buildings);
        setInitializing(false);
      }
      else {
        cogoToast.error('Could not fetch data');
        setInitializing(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });

  }


  const handleSubmit = () => {
    if(name == '') {
      cogoToast.error('Floor name is required');
      return;
    }
    if(building === null) {
      cogoToast.error('Building is required');
      return;
    }

    let data = {
      id: props.match.params.id ? props.match.params.id : 'new',
      name: name,
      status: status,
      building_id: building == null ? null : building.value,
      property_id: props.filterProperty.id,
      block_id: props.filterBlock.id,
    };

    // console.log('data', data);

    setLoading(true);
    setErrors([]);
    // axios.post('/api/beacon/create', {
    post(url.POST_NEW_FLOOR, data)
    .then((response) => {
      console.log('RESP', response);
      if(response.status == 200) {
        history.push('/floors/index');
        cogoToast.success('Floor '+ (props.match.params.id ? (props.match.params.id == 'new' ? 'added' : 'updated') : 'added') + ' successfully');
      }
      else if(response.status == 400) {
        setErrors(Object.values(response.error));
      }
      else {
        console.log('err::', response);
      }
    }, (error) => {
      console.log(error);
      setLoading(false);
    });

  };


  React.useEffect(()=>{
    if(props.filterBlock) {
      setBuilding(null);
      init();
    }
  }, [props.filterBlock]);

  React.useEffect(()=>{

    if(props.match.params.id && props.match.params.id !== 'new') {
      // setName(props.match.params.id.name);
      fetchData(props.match.params.id);
    }
  }, []);


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.match.params.id ? (props.match.params.id == 'new' ? 'Add New' : 'Edit') : 'Add New'} Add Floor | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">{props.match.params.id ? (props.match.params.id == 'new' ? 'New' : 'Edit') : 'New'} Floor</h3>
            <Link className="btn btn-secondary" to="/floors/index">Back</Link>
          </div>


          {errors.length > 0 &&
          <div className="mt-3 mb-5">
            {errors.map((error, errorIdx)=>(
              <Alert key={errorIdx} color="danger">
                <i className="mdi mdi-alert-circle-outline me-2"></i>{error}
              </Alert>
            ))}
          </div>
          }

          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">BASIC DETAILS</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="row mt-2">
                <div className="col">
                  <div className="mb-4 row">
                    <label htmlFor="activityName" className="col-sm-3 col-form-label">Floor Name</label>
                    <div className="col-sm-9">
                      <input autoFocus type="text" className="form-control" id="name"  value={name} onChange={e=>{ setName(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="selectBuilding" className="col-sm-3 col-form-label">Building</label>
                    <div className="col-sm-9">
                      <Select
                        classNamePrefix="select2-selection"
                        placeholder="Select one"
                        id="selectBuilding"
                        title="Building"
                        options={buildings}
                        value={building}
                        onChange={e=>{setBuilding(e);}}
                        />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="status" className="col-sm-3 col-form-label">Status</label>
                    <div className="col-sm-9">
                      <select className="form-control" placeholder="Select one" 
                        value={status}
                        onChange={(e)=>{ setStatus(e.target.value); }}
                        >
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>


     </Container>

    <div className="mb-4 container">
      <div className="d-flex justify-content-center">
        <button type="button" className="btn btn-primary me-2" onClick={()=>{ handleSubmit(); }}>Submit</button>
        <Link className="btn btn-light" to="/floors/index">Cancel</Link>
      </div>
    </div>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(NewFloor)